<script>
import Base from "@/components/RequestDetailsForDefaultVue/ProccessQualityInDefaultView.vue";

export default {
  name: "CustomerServiceFilesProccessQualityInDefaultView",
  extends: Base,
};
</script>
